exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discount-info[data-v-39dcc3c4]{color:#666;font-size:12px}.discount-info .t[data-v-39dcc3c4]{margin-right:20px}.discount-info .tag[data-v-39dcc3c4]{display:inline-block;padding:4px 6px;margin-right:8px;background:#e9eff4;border-radius:4px;cursor:pointer}", ""]);

// exports
